import { Circle, Combine, Construction, Square } from 'lucide-react'

export const getIconForType = (apiType: string) => {
  if (apiType.includes('Z-Pile')) return Square
  if (apiType.includes('O-Pile')) return Circle
  if (apiType.includes('I-Pile') || apiType.includes('IZ')) return Construction
  if (apiType.includes('OZ')) return Combine
  return Square
}
